import { c as _c } from "react/compiler-runtime";
import { SelectRole } from "@components/role/select-role";
import { FaroCoreApiConst } from "@stellar/core-api-client";

/**
 *  Renders a dropdown to select project role
 *  TODO: Refactor this component to handle only TableCell fields, as it is no longer used for non-TableCell fields
 *  https://faro01.atlassian.net/browse/ST-2993.
 */
export function SelectProjectRole(t0) {
  const $ = _c(12);
  const {
    selectedRole,
    onChange,
    variant,
    disabledRoles: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const disabledRoles = t2;
  let t3;
  if ($[2] !== onChange) {
    t3 = function onSelectRoleChange(role) {
      onChange(role);
    };
    $[2] = onChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onSelectRoleChange = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["RESOURCE_OWNER"];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== disabledRoles) {
    t5 = t4.concat(disabledRoles);
    $[5] = disabledRoles;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onSelectRoleChange || $[8] !== selectedRole || $[9] !== t5 || $[10] !== variant) {
    t6 = <SelectRole label="Project role" roles={FaroCoreApiConst.allProjectRoles} disabledRoles={t5} variant={variant} selectedRole={selectedRole} onChange={onSelectRoleChange} link="projectRolesHelp" />;
    $[7] = onSelectRoleChange;
    $[8] = selectedRole;
    $[9] = t5;
    $[10] = variant;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}